import React from 'react';
import { Redirect } from "react-router-dom";

import { getApp } from '../../index';
import { postToApi } from '../../Api/postToApi';

class Form extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            fireRedirect: false,
            completeApplication: false
        }
    }

    // Based on the progress label, perform the necessary check prior redirecting to next page
    // If validation fail, update the eMessage and display on the UI
    submitForm = (e) => {

        e.preventDefault();

        var stepCheck = getApp('progLabel');
        var eligibilityCheck = getApp('currentActiveAz');
        var authCheck = getApp('auth1');
        const blockAgCheck = getApp('blockAgreements');
        // var termsConditions = getApp('membershipQualification');
        var blockDis = getApp('blockDisclosures');
        var blockDOB = getApp('blockAge');
        var caBlockDOB = getApp('caBlockAge');
        // var auBlockDOB = getApp('auBlockAge');
        var blockAuDisclosure = getApp('blockAuDisclosure');
        // var promoRequireValidate = getApp('promoCodeNeedValidate');
        // var blockPromo = getApp('blockPromo');
        // var blockZeros = getApp('blockZeros');
        var monthField = document.getElementById('#monthsField');
        // const complete = this.state.completeApplication;
        var eMessage;

        if (stepCheck === 'Final Review' && blockAgCheck === false) {
            postToApi();
            this.setState({ fireRedirect: true });
            window.scrollTo(0, 0);
        } else {
            if (eligibilityCheck === "false" && stepCheck === "Eligibility"){
                alert("We are sorry but you are not eligible for the loan product at the moment.");
                window.location.href = 'https://vantagewest.org/personal/credit-cards/';
            }
            else if (!authCheck && stepCheck === "Intro") {
                eMessage = document.querySelector('.auth1-required-message');
                eMessage.classList.add('show');
            } else if (blockAgCheck === true && stepCheck === "Final Review") {
                alert('Please check the agreement box to continue.');
            } else if (blockDis && stepCheck === 'Disclosures') {
                alert('Please read the disclosure documents to continue.');
            } else if (blockDOB && stepCheck === "Verification") {
                eMessage = document.querySelector('.dob-message');
                eMessage.classList.add('show');
            } else if (caBlockDOB && stepCheck === "Co-Applicant Info") {
                eMessage = document.querySelector('.cadob-message');
                eMessage.classList.add('show');
            } else if (blockAuDisclosure === true && stepCheck === "Authorized User") {
                alert('Please check the disclosure box to continue.');
                // }else if ((blockPromo === true || promoRequireValidate == true) && stepCheck === "Promo Code"){
                //     eMessage = document.querySelector('.promocode-message');
                //     eMessage.classList.add('show');
            } else if (document.body.contains(monthField)) {
                eMessage = document.querySelector('.months-message');
                eMessage.classList.add('show');
                //}else if(blockZeros){
                //why is this here and why is it blank?
            } else {
                this.setState({ fireRedirect: true });
                window.scrollTo(0, 0);
            }
        }
    }

    render() {
        return (
            <div>
                <form className="loanApp-form" onSubmit={this.submitForm} >
                    {this.props.children}
                </form>
                {this.state.fireRedirect && (
                    <Redirect to={this.props.nextLink} />
                )}
            </div>
        )
    }
}

export default Form;